  import React from 'react';
  import {
    Input
  } from "design-react-kit";

  const BodyGenerateCsv = ({ sendImportCSV, setSendImportCSV }) => {
    const today = new Date();
    today.toLocaleString("default", { month: "long" });
  
    return (
      <>
        <div className="row mb-lg-5">
          Inserisci il mese e l'anno per cui generare il CSV, altrimenti verranno inseriti di default mese e anno correnti:
        </div>
        <div className="row">
          <div className="col-lg-6">
            <Input
              id="mese"
              label="Mese"
              type="text"
              name="mese"
              placeholder={today
                .toLocaleString("default", { month: "short" })
                .toUpperCase()}
              value={sendImportCSV.mese}
              onChange={(e) =>
                setSendImportCSV({ ...sendImportCSV, mese: e.target.value })
              }
            />
          </div>
          <div className="col-lg-6">
            <Input
              id="anno"
              label="Anno"
              type="text"
              name="anno"
              placeholder={today.getFullYear().toString()}
              value={sendImportCSV.anno}
              onChange={(e) =>
                setSendImportCSV({ ...sendImportCSV, anno: e.target.value })
              }
            />
          </div>
        </div>
      </>
    );
  };
  
  export default BodyGenerateCsv;
  